import { ApiUtility } from "./ApiUtility";

class GeetGovindServices {
  geetfilterRoute = "/api/settings/filters?lang=";
  magzinedata = "/api/monthlymagazines?lang=";
  magzinedetailRoute = "/api/MonthlyMagazines/";
  favourite = "/api/monthlymagazines/";
  allMagazines = "/api/magazines";

  /** Mobile stores hi/en; Monthly Magazine APIs expect hindi/english */
  private getLangParam(): string {
    const lan = localStorage.getItem("lan") || "hindi";
    return lan === "hi" ? "hindi" : lan === "en" ? "english" : lan;
  }

  getGeetFilters(productFor: string) {
    return ApiUtility.get(
      this.geetfilterRoute +
      this.getLangParam() +
      "&productFor=" +
      productFor
    );
  }

  getMonthlyMagazine(
    search: string,
    start: number,
    length: number,
    categoryId: string,
    IsChildLiterature: boolean,
    sort: string,
    authorId: string,
    monthlymagazineLangauge: string,
    isSpecial: boolean,
    subjectId: string,
    userId?: string
  ) {
    let url =
      this.magzinedata +
      this.getLangParam() +
      "&search=" +
      search +
      "&start=" +
      start +
      "&length=" +
      length +
      "&categoryId=" +
      categoryId +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&sort=" +
      sort +
      "&authorId=" +
      authorId +
      "&monthlymagazineLangauge=" +
      monthlymagazineLangauge +
      "&isSpecial=" +
      isSpecial +
      "&subjectId=" +
      subjectId;
    if (userId) {
      url += "&userId=" + userId;
    }
    return ApiUtility.get(url);
  }

  getcurrentGeetGovind(id: string) {
    return ApiUtility.get(
      this.magzinedetailRoute +
      id +
      "?lang=" +
      this.getLangParam()
    );
  }

  getNavigationDetails(id: string) {
    return ApiUtility.post(this.magzinedetailRoute + "navigation-details", {
      monthlyMagazineId: id,
    });
  }

  /**
   * Related editions for a monthly magazine.
   * Optional lang / languageId are used by desktop GeetGovindDetailPage only
   * so related items match the current issue language. Callers that omit them
   * keep the previous localStorage lan behavior (mobile unchanged).
   */
  getRelatedGeetGovind(id: string, lang?: string, languageId?: string) {
    const resolvedLang = lang || this.getLangParam();
    let url =
      this.magzinedetailRoute +
      id +
      "/related?lang=" +
      resolvedLang;
    // Desktop-only filter: same magazine language catalog as the open issue
    if (languageId) {
      url += "&monthlymagazineLangauge=" + languageId;
    }
    return ApiUtility.get(url);
  }


  getGeetGovindDetail = (id: string) => {
    const lang = this.getLangParam();
    return ApiUtility.get(`${this.magzinedetailRoute}${id}/SEO?lang=${lang}`);
  };

  addGeetGovindFavourite = (id: string) => {
    return ApiUtility.post(this.favourite + id + "/favourite", {});
  };

  removeGeetGovindFavourite = (id: string) => {
    return ApiUtility.delete(this.favourite + id + "/favourite");
  };

  getcurrentMagazine(id: string, userId: string) {
    return ApiUtility.get(
      this.magzinedetailRoute +
      id +
      "?UserId=" +
      userId +
      "&lang=" +
      this.getLangParam()
    );
  }

  getAllMagazines(lang?: string, start?: number, length?: number) {
    const url = `${this.allMagazines}?lang=${lang}&start=${start}&length=${length}`;
    return ApiUtility.get(url);
  }

  getMagazineById(id: any, userId: any) {
    // Match getcurrentMagazine — API expects UserId + lang
    const safeUserId = userId ?? localStorage.getItem("UserId") ?? "";
    const lang = this.getLangParam();
    const url = `${this.magzinedetailRoute}${id}?UserId=${safeUserId}&lang=${lang}`;
    return ApiUtility.get(url);
  }

  addMagzineFavourite = (id: string) => {
    return ApiUtility.post(this.favourite + id + "/favourite", {});
  };

  removeMagzineFavourite = (id: string) => {
    return ApiUtility.delete(this.favourite + id + "/favourite");
  };

  GetLanguageDataById(id: string) {
    return ApiUtility.get(
      "/api/languages/" + id + "?lang=" + this.getLangParam()
    );
  }

  GetCategoryDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/MonthlyMagazines/Categories/${identifier}?lang=` + this.getLangParam()
    );
  }

  GetAuthorDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/MonthlyMagazines/Authors/${identifier}?lang=` + this.getLangParam()
    );
  }
}
export default new GeetGovindServices();
